import { ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

const FOCUSABLE_ELEMENT_SELECTOR = 'input, textarea, select, button, [tabindex]:not([tabindex="-1"])';

export function scrollToFirstInvalidControl(form: FormGroup, elementRef: ElementRef<HTMLElement>): void {
    form.markAllAsTouched();

    let firstInvalidControlElement = elementRef.nativeElement.querySelector<HTMLElement>('mat-form-field.ng-invalid');

    if (!firstInvalidControlElement) {
        firstInvalidControlElement = elementRef.nativeElement.querySelector<HTMLElement>('.ng-invalid');
    }

    if (firstInvalidControlElement) {
        const focusableElement = firstInvalidControlElement.querySelector<HTMLElement>(FOCUSABLE_ELEMENT_SELECTOR);

        const elementToFocus = focusableElement || firstInvalidControlElement;

        elementToFocus.scrollIntoView({ behavior: 'smooth', block: 'center' });

        if (typeof elementToFocus.focus === 'function') {
            setTimeout(() => elementToFocus.focus(), 300);
        }
    } else {
        console.warn('Form is invalid, but no invalid control was found in the DOM.');
    }
}
